import moment from 'moment-timezone';
import { Dispatch } from 'react';
import { didCrossPinkdoorAfterTimeSpecified, getSolvUserDate } from '~/core/util/account';
import { analyticsTrackEvent } from '~/core/analytics';
import {
  CROSSED_PINK_DOOR,
  CROSSED_PINK_DOOR_TYPE_ACCEPTED_TOS_ACCOUNT,
} from '~/core/analytics/events';
import { noOp } from '~/actions';
import { isAndroidApp, isAndroidOS, isIOS, isIosApp } from '~/core/util/device';
import { apiPostDispatchable } from '~/core/dapi';
import { setPinkDoorTosAccepted } from '~/core/dapi/account';

export const setPinkDoorTosWithDispatch = (accountId: string, dispatch: Dispatch<any>) => {
  const setTosAcceptedTimestamp = moment();
  const onSuccess = (response: any) => {
    const didJustCrossPinkDoor = didCrossPinkdoorAfterTimeSpecified(
      response,
      setTosAcceptedTimestamp
    );
    if (didJustCrossPinkDoor) {
      analyticsTrackEvent(CROSSED_PINK_DOOR, {
        solv_user_date: getSolvUserDate(response),
        type: CROSSED_PINK_DOOR_TYPE_ACCEPTED_TOS_ACCOUNT,
      });
    }
    return noOp();
  };
  const data = {
    is_ios_user: isIOS(),
    is_android_user: isAndroidOS(),
    is_ios_app_user: isIosApp(),
    is_android_app_user: isAndroidApp(),
  };

  dispatch(apiPostDispatchable(setPinkDoorTosAccepted(accountId), data, onSuccess, noOp));
};
